// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2pTtX","image":"Header_image__lQScL","name":"Header_name__3gyUt","info":"Header_info__k_XJ8","infoRow":"Header_infoRow__1yRTQ"};